// ============================================
// Smith & Jengs - Centralized Asset Configuration
// All CDN references consolidated in one place
// ============================================

const CDN_BASE = 'https://cdn.magicpatterns.com/uploads/'

/**
 * Centralized asset registry.
 * Each key is the clean filename used in /assets/ paths.
 * The value is the full CDN URL for runtime use.
 *
 * To migrate a component: import { ASSETS } from '../config/assets'
 * Then use ASSETS['filename'] instead of the hardcoded CDN URL.
 */
export const ASSETS: Record<string, string> = {
  // ── Branding & Logos ──────────────────────────
  'sj-website-logo-colour.svg': `${CDN_BASE}5m425UHDJynsrvkfvBo6sp/sj-website-logo-colour.svg`,
  'sj-website-logo-white.svg': `${CDN_BASE}1h9RWLFQ7TTAoyFwfGSDao/sj-website-logo-white.svg`,
  'sj-website-sj-text-header.svg': `${CDN_BASE}sUut1eTBvUUEHm5bBaK9Yr/sj-website-sj-text-header.svg`,
  'sj-website-sj-text-stacked-white.svg': `${CDN_BASE}9gJT63RaUddpyfpZWktWUn/sj-website-sj-text-stacked-white.svg`,
  'sj-website-sj-text-stacked-colour.svg': `${CDN_BASE}iQahCaoqLWtvpaEqqgu2am/sj-website-sj-text-stacked-colour.svg`,

  // ── Homepage - Hero Banner ────────────────────
  'sj-website-home-banner-1.png': `${CDN_BASE}fssYpKf8swLzdNNaRcNwxG/sj-website-home-banner-1.png`,
  'sj-website-home-banner-2.png': `${CDN_BASE}3idp1uY2N511JBaJj5HAAE/sj-website-home-banner-2.png`,
  'sj-website-home-banner-3.png': `${CDN_BASE}hWKiPjjFohRqkseJ6Qufg5/sj-website-home-banner-3.png`,
  'sj-website-home-banner-4.png': `${CDN_BASE}vMP5ojfesyNXc5k5Zm6z65/sj-website-home-banner-4.png`,
  'sj-website-home-banner-5.png': `${CDN_BASE}jrwLvEej2KvpzukSqKcwMX/sj-website-home-banner-5.png`,

  // ── Homepage - BookOnline Slider ──────────────
  'smith-jengs-bathroom.jpg': `${CDN_BASE}7ycogXYPVW45FbgwzUamq4/smith-jengs-bathroom.jpg`,
  'smith-jengs-raomubashir14.jpg': `${CDN_BASE}4grtg2gWoCrfFxFvzRgA7d/smith-jengs-raomubashir14.jpg`,
  'smith-jengs-peter-vang.jpg': `${CDN_BASE}aM4ZmkxceRDD2KuGcWxwQi/smith-jengs-peter-vang.jpg`,
  'smith-jengs-curtis-adams.jpg': `${CDN_BASE}oSfGn7SQLwZ7JhfPnNiNVP/smith-jengs-curtis-adams.jpg`,
  'smith-jengs-2-mirrors.jpg': `${CDN_BASE}xzhXBUhziFkQPiXqtogJRV/smith-jengs-2-mirrors.jpg`,

  // ── Homepage - OurServices ────────────────────
  'sj-website-home-img1.png': `${CDN_BASE}qvCeQwTAdJwGp7cTDszDSa/sj-website-home-img1.png`,

  // ── Homepage - HousekeepingRevolution ─────────
  'yellow-armchair-living-room-with-copy-space.jpg': `${CDN_BASE}1ysEQkSYQsjQLUL79tMi5e/yellow-armchair-living-room-with-copy-space.jpg`,
  'smith-jengs-staircase.jpg': `${CDN_BASE}jCYKPufVWt6FxbUYi6bj6W/smith-jengs-staircase.jpg`,

  // ── Homepage - FAQ & WhyChooseUs ──────────────
  'smith-jengs-alexander.jpg': `${CDN_BASE}ncmTrhjXda5TCzagpqynj8/smith-jengs-alexander.jpg`,

  // ── Commercial Cleaning ───────────────────────
  'sj-website-commercial-img1.png': `${CDN_BASE}jJ8rqPBAtF8Zv1F3SffbkU/sj-website-commercial-img1.png`,
  'sj-website-commercial-img2.png': `${CDN_BASE}hsYfHybdP8AFrJp4GWQcRc/sj-website-commercial-img2.png`,

  // ── Basic Home Cleaning ───────────────────────
  'sj-website-basic-home-banner.png': `${CDN_BASE}hALs7bhhgH38SiEkLYefJP/sj-website-basic-home-banner.png`,
  'sj-website-basic-home-img1.png': `${CDN_BASE}5bb5rmi764n2bkspfQtkCD/sj-website-basic-home-img1.png`,
  'sj-website-basic-home-img2.png': `${CDN_BASE}84G2ZbMVURvjbuFpe5csPV/sj-website-basic-home-img2.png`,

  // ── Spring / Deep Cleaning ────────────────────
  'sj-website-deep-clean-banner.png': `${CDN_BASE}pwzkMp41NqfVwFtPzbYese/sj-website-deep-clean-banner.png`,
  'kitchen-clean-dog.png': `${CDN_BASE}emDHfxCvuYnUEkXibGbjn6/kitchen-clean-dog.png`,
  'lady-cleaning-window.png': `${CDN_BASE}rJgFvMvZju8gYeLxkrt7X2/lady-cleaning-window.png`,

  // ── About Us ──────────────────────────────────
  'banner2.jpg': `${CDN_BASE}3JFURjPXF23VB8fYkgvyfU/banner2.jpg`,
  'sj-website-about-us-img1.png': `${CDN_BASE}2WeZZixMbHWHWumyRho3jN/sj-website-about-us-img1.png`,
  'sj-website-icon-vision.svg': `${CDN_BASE}cNw4ytSvu8TRB5FWzAM39L/sj-website-icon-vision.svg`,
  'sj-website-icon-mission.svg': `${CDN_BASE}hfWqi7BxuQgxuC5DJ7Y7Uq/sj-website-icon-mission.svg`,
  'sj-website-icon-values.svg': `${CDN_BASE}gvQFgcBNGuC1NT9t4kdNf8/sj-website-icon-values.svg`,
  'sj-website-about-us-img2.png': `${CDN_BASE}4dCG9caDvnearhVDSUwvXN/sj-website-about-us-img2.png`,

  // ── Contact Us & FAQ ──────────────────────────
  'sj-website-contact-us-banner.png': `${CDN_BASE}6QKxnCfN2Sqn8DtA2jU5tB/sj-website-contact-us-banner.png`,
  'sj-website-contact-us-img1.png': `${CDN_BASE}e78W1heVEAoUdPavobxBNo/sj-website-contact-us-img1.png`,
  'sj-website-contact-us-map.png': `${CDN_BASE}b6BxcUSupiMq6jBRvxQfCM/sj-website-contact-us-map.png`,
  'sj-website-faq-banner.png': `${CDN_BASE}k9prZ3TeuQMtKoLyUYkUo3/sj-website-faq-banner.png`,
}

/**
 * External images (not hosted on our CDN).
 * These are kept separate since they can't be white-labeled.
 */
export const EXTERNAL_IMAGES: Record<string, string> = {
  'office-photo.jpg':
    'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80',
}

/**
 * Helper: resolve an asset name to its CDN URL.
 * Falls back to /assets/{name} if not found (for local dev).
 */
export function resolveAsset(name: string): string {
  return ASSETS[name] || EXTERNAL_IMAGES[name] || `/assets/${name}`
}

/**
 * Helper: get the clean /assets/ path for an asset name.
 */
export function cleanAssetPath(name: string): string {
  return `/assets/${name}`
}

/**
 * Helper: strip all CDN URLs from a string, replacing with clean /assets/ paths.
 * Useful for export functions that need white-labeled output.
 */
export function stripCdnUrls(content: string): string {
  // Replace full CDN URLs with clean /assets/ paths
  return content.replace(
    /https:\/\/cdn\.magicpatterns\.com\/uploads\/[a-zA-Z0-9]+\/([^\s"'<>]+)/g,
    '/assets/$1',
  )
}
